export default __webpack_public_path__ + "static/media/blueClock.940cd9ba.svg";